<header>
	@if (showSideNavToggle$ | async) {
		<button
			class="icon-btn side-nav-button ficon-menu"
			type="button"
			[attr.aria-label]="'dashboard_expand-sidebar' | translate"
			(click)="toggleSideNav.emit()">
		</button>
	}
	
	@if (showLogo) {
		<logo></logo>
	}

	<breadcrumbs></breadcrumbs>
	<div class="header-menu">
		<button [matMenuTriggerFor]="menu"
			type="button"
			class="user-menu btn-none goreact-btn link-btn"
			[attr.aria-label]="('menu-button_user' | translate) + ' Button, ' + (currentUser.fullname || currentUser.full_name)"
			aria-haspopup="menu"
			data-cy="user-navigation-dropdown"
			[ngClass]="{ 'hide-dropdown': isMasked() }">
			<span class="display-name">
				<span class="user-name" [ngClass]="{ 'is-masked': isMasked() }">{{ currentUser.fullname || currentUser.full_name }}</span>
				@if (isMasked()) {
					<span class="unmask-indicator"><i class="ficon-times-circle"></i></span>
				}
			</span>
			<span class="display-icon">
				<i class="ficon-app-user" [ngClass]="{ 'icon-masked': isMasked() }"></i>
				@if (isMasked()) {
					<span class="unmask-indicator"><i class="ficon-times-circle"></i></span>
				}
			</span>
			<i class="down-arrow ficon-search-chevron-down"></i>
		</button>
		<mat-menu #menu="matMenu">
			@if (isMasked()) {
				<button
					mat-menu-item class="account-item is-masked unmask"
					[attr.aria-label]="'header_exit-mask-view' | translate"
					(click)="unMask()">
					{{ 'header_exit-mask-view' | translate }}
					<mat-icon class="ficon-times-circle"></mat-icon>
				</button>
				<mat-divider></mat-divider>
			}
			@if (showAccountSettings()) {
				<button mat-menu-item (click)="openAccountSettingsPage()" class="account-item new-settings" data-cy="new-account-settings"><span translate="header_account-settings"></span></button>
			}
			@if (shouldShowAdminTools()) {
				<button mat-menu-item (click)="openAdminToolsPage()" class="account-item admin-tools-lnk"><span translate="header_admin-tools"></span></button>
			}
			<mat-divider></mat-divider>
			@if (showTermsForOrg$ | async) {
				<a mat-menu-item href="https://get.goreact.com/terms" target="_blank" class="terms-lnk"><span translate="footer_terms"></span></a>
			}
			<a mat-menu-item href="https://get.goreact.com/privacy" target="_blank" class="privacy-lnk"><span translate="footer_privacy"></span></a>
			<a mat-menu-item [attr.href]="helpUrls.security" target="_blank" class="compliance-lnk"><span translate="header_compliance"></span></a>
			<a mat-menu-item [attr.href]="helpUrls.accessibility" target="_blank" class="accessibility-lnk"><span translate="header_accessibility"></span></a>

			@if (!isLTI) {
				<mat-divider></mat-divider>
				<button mat-menu-item (click)="openMobileApp()" class="dl-pwa"><span translate="header_mobile-app"></span></button>
				<button mat-menu-item (click)="logout()" class="logout-btn" data-cy="logout"><span translate="log-out"></span></button>
			}
		</mat-menu>
	</div>
	@if (shouldShowSaveAndExitButton()) {
		<div class="save-and-exit-button-container">
			<a href="{{getLaunchPresentationUrl()}}" data-cy="save-and-exit" class="primary-btn" [attr.aria-label]="'save_and_exit' | translate"><span translate="save_and_exit"></span></a>
		</div>
	}
</header>
